export const GET_BOOKED_APPOINTMENTS_REQUEST = 'GET_BOOKED_APPOINTMENTS_REQUEST';
export const GET_BOOKED_APPOINTMENTS_SUCCESS = 'GET_BOOKED_APPOINTMENTS_SUCCESS';
export const GET_BOOKED_APPOINTMENTS_FAILURE = 'GET_BOOKED_APPOINTMENTS_FAILURE';